import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=4221b215&scoped=true&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=4221b215&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4221b215",
  null
  
)

export default component.exports